<template>
  <div class="kyujitsu detail-item">

    <div class="head"><b>休日</b></div>
    <p class="pre">{{ Message.HOLIDAY }}</p>
    
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Message from "@/const/KoyouKeiyaku/Message";

export default defineComponent({
  setup() {
    return {
      Message
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-detail.scss';

</style>
